module.exports = __webpack_public_path__ + "static/img/bg-banner-case-detail-bridge.4e81ebee.png";